var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4927 5.73236L19.1366 1.4826C19.0895 1.336 18.9976 1.20956 18.8752 1.12259C18.7528 1.03562 18.6064 0.992901 18.4586 1.00096H3.54142C3.39356 0.992901 3.24724 1.03562 3.1248 1.12259C3.00237 1.20956 2.91055 1.336 2.86337 1.4826L1.50726 5.73236C1.49758 5.80757 1.49758 5.8838 1.50726 5.95902V10.2088C1.50726 10.3966 1.5787 10.5768 1.70586 10.7096C1.83302 10.8424 2.00549 10.9171 2.18532 10.9171H2.86337V18H4.21948V10.9171H8.28779V18H19.1366V10.9171H19.8147C19.9945 10.9171 20.167 10.8424 20.2941 10.7096C20.4213 10.5768 20.4927 10.3966 20.4927 10.2088V5.95902C20.5024 5.8838 20.5024 5.80757 20.4927 5.73236ZM17.7805 16.5834H9.6439V10.9171H17.7805V16.5834ZM19.1366 9.50048H16.4244V6.66731H15.0683V9.50048H11.6781V6.66731H10.3219V9.50048H6.93168V6.66731H5.57558V9.50048H2.86337V6.07234L4.02962 2.41755H17.9704L19.1366 6.07234V9.50048Z",
    fill: "#4E4B66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderStore);
export default __webpack_public_path__ + "static/media/headerStore.5d72193ffd26cb3b136cd3e1d04760c7.svg";
export { ForwardRef as ReactComponent };